import React from 'react';
import Container from '@mui/material/Container';

const withContainer = (WrappedComponent) => (props) => (
  <Container maxWidth="lg">
    <WrappedComponent {...props} />
  </Container>
)
export default withContainer;
